export default {
  simulationData: 'Simulačné dáta',
  showPreview: 'Náhľad receptúry simulátora',
  selectUnitHeader: 'Systém jednotiek',
  timeoutSeconds: 'Maximálny čas simulácie',
};
